const postOfficeCities = ['APO', 'FPO'];

export default postOfficeCities;
